module.exports = __webpack_public_path__ + "media/components/assets/icons/star_half-91733f83b8601473061f2d12bb5c72e2.svg";